module.exports = function UpdateSourceUpdateResponse(error) {
    this.error = error;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-update-response.js
// module id = 321
// module chunks = 0